var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 0C3.0874 0 0.66009 2.07555 0.11499 4.82812H1.78052C2.2937 2.97756 3.98603 1.61719 6 1.61719C7.21069 1.61719 8.30474 2.10914 9.09668 2.90332L7.17188 4.82812H12V0L10.2422 1.75781C9.15653 0.67181 7.65698 0 6 0ZM0 7.17188V12L1.75781 10.2422C2.84346 11.3282 4.34302 12 6 12C8.9126 12 11.3399 9.92445 11.885 7.17188H10.2195C9.70631 9.02243 8.01396 10.3828 6 10.3828C4.78931 10.3828 3.69526 9.89086 2.90332 9.09668L4.82812 7.17188H0Z",
    fill: "#00D315",
    fillOpacity: 0.81
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.118d8353cdce613998658634e90a941c.svg";
export { ForwardRef as ReactComponent };